import {PageContainer} from '@hconnect/uikit/src/lib2'
import {RefererName, type StepFormRef, type SubmitButtonState} from '@widgets/hroc-checklists'
import {useRef, useState} from 'react'
import {useTranslation} from 'react-i18next'
import {useNavigate, useParams, useSearchParams} from 'react-router'

import {ChecklistRefererLabelKeyMap, FEATURE_NAMESPACE} from '../consts'
import {ChecklistContainer, ChecklistPageHeaderContainer} from '../containers'

type PathParameter = {
  checklistId?: string
  refererName?: RefererName
}

type Props = {
  plantId: string
}

export const ChecklistPage = ({plantId}: Props) => {
  const {checklistId} = useParams<PathParameter>()
  if (!checklistId) throw new Error('checklistId is missing')
  const {refererName} = usePlantChecklistPageSearchParams()

  const {t} = useTranslation(FEATURE_NAMESPACE)
  const navigate = useNavigate()
  const stepFormRef = useRef<StepFormRef>(null)
  const [submitButtonState, setSubmitButtonState] = useState<SubmitButtonState>({
    isVisible: false,
    isSubmitting: false
  })

  const handleNavigateBack = () => {
    void navigate(-1)
  }

  const targetBackToName = refererName
    ? t('action.backToTarget', {targetName: t(`${ChecklistRefererLabelKeyMap[refererName]}`)})
    : t('action.goBack')

  const handleSubmit = () => {
    stepFormRef.current?.submit()
  }

  return (
    <PageContainer>
      <ChecklistPageHeaderContainer
        checklistId={checklistId}
        plantId={plantId}
        backButtonProps={{
          target: '..', // Not used cause overrided by onNavigate, but required in BackButtonProps type
          targetName: targetBackToName,
          onNavigate: handleNavigateBack
        }}
        onSubmitClick={submitButtonState.isVisible ? handleSubmit : undefined}
        isSubmitting={submitButtonState.isSubmitting}
      />
      <ChecklistContainer
        checklistId={checklistId}
        plantId={plantId}
        onCancel={handleNavigateBack}
        backToTargetLabel={targetBackToName}
        stepFormRef={stepFormRef}
        onSubmitButtonStateChange={setSubmitButtonState}
      />
    </PageContainer>
  )
}

const usePlantChecklistPageSearchParams = (): {
  refererName: string | null
} => {
  const [params] = useSearchParams()
  const refererName = params.get('refererName')

  return {refererName}
}
